import { render, staticRenderFns } from "./xw-t-table.vue?vue&type=template&id=a836d694&scoped=true"
import script from "./xw-t-table.vue?vue&type=script&lang=js"
export * from "./xw-t-table.vue?vue&type=script&lang=js"
import "./xw-t-table.vue?vue&type=style&index=0&id=a836d694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a836d694",
  null
  
)

export default component.exports